import React, { useRef, useEffect } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import resetStorageBookingValues from 'Functions/resetStorageBookingValues';
import { isTrue, num, formatNum } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const CGU_ERROR = 'Vous devez accepter les conditions de vente et d\'annulation.';
const {
  app
} = window;
export default function SubmitCompanyBooking(props) {
  const state = BookingFormStore.useState(s => s);
  const id = BookingFormStore.useState(s => s.company_submit_form_id);
  const _ref_submit = useRef();
  useEffect(function (e) {
    // empêche l'envoi du formulaire si autre chose que l'id de soumission change
    if (!id || _ref_submit.current === id) return;
    _ref_submit.current = id;
    if (!isTrue(state.b2b)) return;
    if (state.submitting) return;
    if (!isTrue(state.cgu_accepted)) {
      return BookingFormStore.update(function (store) {
        store.error = CGU_ERROR;
      });
    }
    e?.persist?.();
    BookingFormStore.update(function (store) {
      store.submitting = true;
    });
    if (state.loading || state.redirecting) return;
    const session_user = app.state.session?.user || {};
    const user_session = {
      id: session_user.id,
      login: session_user.login,
      lastname: state['user[lastname]'],
      firstname: state['user[firstname]'],
      phone_number: state['user[phone_number]']
    };
    ['coworking_space'].forEach(field => delete user_session[field]);
    const booking = {
      date: state.date,
      number_of_people: state.people,
      start_hour: state.start,
      end_hour: state.end,
      coworking_space: props.space.id,
      disposition: state.disposition,
      amount: state.amount
    };
    (async function () {
      try {
        var response = await ajaxRequest(action('CreateCompanyBooking'), {
          data: {
            user: user_session,
            booking: booking,
            company_id: session_user.company?.id
          }
        });
      } catch (update) {
        BookingFormStore.update(function (store) {
          Object.keys(update).forEach(field => store[field] = update[field]);
          store.submitting = false;
        });
        return;
      }
      const price = formatNum(window.localStorage.getItem('amount'), '0.00');
      app.emit({
        event: 'TC_TunnelEvent',
        source: 'BookingComponent.validateFromCompany',
        data: {
          template: 'paiement',
          page: 'paiement',
          type: 'coworking',
          city: props.space?._etablishment?.address?.city,
          date: state.date,
          etablishment: props.space?._etablishment?.name,
          space: props.space?.name,
          people: state.people,
          booking: state.start && state.end ? state.start + 'h-' + state.end + 'h' : state.start === 'afternoon' ? 'Demi-journée - Après midi' : state.start === 'morning' ? 'Demi-journée - Matin' : state.start === 'day' ? 'Journée' : '',
          services: '',
          price: price,
          price_with_services: price
        }
      });
      BookingFormStore.update(function (store) {
        store.submitting = false;
        store.redirecting = true;
        store.info = response.info;
        store.error = undefined;
        store.warning = undefined;
        store.status_messages = {};
        store.booking_id = response.id;
        store.completed = true;
        resetStorageBookingValues();
      });
    })();
  }, [id, state, props.space]);
  return null;
}
